import { createFileRoute, notFound } from "@tanstack/react-router";

import { ContactView } from "@/components/pages/ContactView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/contact")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/contact",
          ...meta[params.locale].contact,
        })
      : {},
  component: ContactRoute,
});

function ContactRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <ContactView locale={locale} />;
}
